import { createAction } from 'redux-actions'

export const GET_EXTRAS = createAction('GET_EXTRAS')
export const PUT_EXTRAS = createAction('PUT_EXTRAS')
